import template from './terms-of-use.html';
import './terms-of-use.global.css';

export const TermsOfUseComponent = {
  template,
  bindings: {
    buttonText: '@',
  },
};
